/**
 * AG Grid License Manager Utility
 *
 * This module provides lazy initialization of the AG Grid Enterprise license.
 * The license is only loaded and set when the first AG Grid component is mounted,
 * preventing AG Grid from being bundled in the main chunk.
 *
 * Usage:
 * Import and call `initializeAgGridLicense()` in any component that uses AG Grid,
 * preferably in a useEffect hook or before rendering the grid.
 */

let isLicenseInitialized = false;

/**
 * Initialize AG Grid Enterprise license
 * This function is idempotent - it will only set the license once
 */
export async function initializeAgGridLicense(): Promise<void> {
  // Return immediately if already initialized
  if (isLicenseInitialized) {
    return;
  }

  try {
    // Dynamically import AG Grid Enterprise only when needed
    const { LicenseManager } = await import('ag-grid-enterprise');

    LicenseManager.setLicenseKey(
      'Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-093990}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{True_AI}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{TRUE_MOS}_only_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{TRUE_MOS}_need_to_be_licensed___{TRUE_MOS}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{23_September_2026}____[v3]_[0102]_MTc5MDExODAwMDAwMA==5f0d8d053509e1964bb1f0258f7e38e9',
    );

    isLicenseInitialized = true;
  } catch (error) {
    console.error('Failed to initialize AG Grid license:', error);
    throw error;
  }
}

/**
 * Check if AG Grid license has been initialized
 */
export function isAgGridLicenseInitialized(): boolean {
  return isLicenseInitialized;
}
